import React from 'react'
import PropTypes from 'prop-types'
import { Link, graphql } from 'gatsby'
import Layout from '../components/Layout'

export default class IndexPage extends React.Component {
  render() {
    const { data } = this.props
    const { edges: posts } = data.allMarkdownRemark

    return (
      <Layout>
        <section className="hero is-primary is-bold">
          <div className="hero-body">
            <div className="container">
              <h1 className="title">
                Welcome on the BoA website
              </h1>
              <h2 className="subtitle">
                3D-2D CAD software for architecture
              </h2>
              <p className="has-text-light">
                Version 4.4 of BoA is now available, you can download it <a className="has-text-weight-bold" href="/en/boa/downloads">here</a>
              </p>
            </div>
          </div>
        </section>
        <section className="section">
          <div className="container">
            <div className="content">
              <h1 className="has-text-weight-bold is-size-2">Last news</h1>
            </div>
            {posts
              .map(({ node: post }) => (
                <div
                  className="content"
                  style={{ border: '1px solid #eaecee', padding: '2em 4em' }}
                  key={post.id}
                >
                  <p>
                    <Link className="has-text-primary" to={post.fields.slug}>
                      {post.frontmatter.title}
                    </Link>
                    <span> &bull; </span>
                    <small>{post.frontmatter.date}</small>
                  </p>
                  <p>
                    {post.excerpt}
                    <br />
                    <br />
                    <Link className="button is-small" to={post.fields.slug}>
                      Read more →
                    </Link>
                  </p>
                </div>
              ))}
          </div>
        </section>
      </Layout>
    )
  }
}

IndexPage.propTypes = {
  data: PropTypes.shape({
    allMarkdownRemark: PropTypes.shape({
      edges: PropTypes.array,
    }),
  }),
}

export const pageQuery = graphql`
  query IndexQuery_en {
    allMarkdownRemark(
      sort: { order: DESC, fields: [frontmatter___date] },
      filter: { 
        frontmatter: { templateKey: { eq: "blog-post" } },
        fields: { langKey: { eq: "en" }}
      }
    ) {
      edges {
        node {
          excerpt(pruneLength: 400)
          id
          fields {
            slug
            langKey
          }
          frontmatter {
            title
            templateKey
            date(
              formatString: "MMMM DD, YYYY",
              locale: "en"
            )
          }
        }
      }
    }
  }
`
